// extracted by mini-css-extract-plugin
export default {"layoutSwitch":"GalleryNavigation_layoutSwitch__yRT9V","paginationSwitch":"GalleryNavigation_paginationSwitch__KZ6kW"};